import Members from "./Members";

// Members' entry for the sidebar. It is a direct section (like Dashboard, Users or Departments):
// the section carries its own page, so one click opens it. It lives here, not inline in
// sidebarConstant.js, so the sidebar's behaviour for Members can be tested without loading every
// page in the app. sidebarConstant.js adds the icon so it matches its siblings.
export const membersSidebarSection = {
  title: "Members",
  app: "members", // shown only when the tenant's `apps` has "members" (the members_module setting)
  component: Members,
  roles: ["admin", "manager", "user"],
  enforceAccess: true, // the sidebar also limits it to `roles` and falls back to the dashboard when it is gone
};
